function fixProductAddToCartBtn() {
    const addToCartBtn = document.querySelector('.product-single__meta [data-add-to-cart]'),
        btnBlockWrapper = addToCartBtn.closest('.product-block'),
        btnRect = btnBlockWrapper.getBoundingClientRect();
    if (btnBlockWrapper) {
        if (btnRect.top < 50) {
            btnBlockWrapper.classList.add('fixed');
            btnBlockWrapper.style.padding = `${addToCartBtn.offsetHeight}px 0 0`;
        } else {
            btnBlockWrapper.classList.remove('fixed');
            btnBlockWrapper.removeAttribute('style');

        }
    }
}
if(document.body.classList.contains('template-product')){
    fixProductAddToCartBtn()
    document.addEventListener('scroll',fixProductAddToCartBtn);
}

document.addEventListener('change', function(event) {
    console.log(event.target)
    if (event.target.tagName === 'SELECT' && event.target.classList.contains('js-select-quick-add')) {
        var form = event.target.closest('form');

       if (form) {
           var button = form.querySelector('button[data-add-to-cart]');
         if (button) {
                button.click();
            }
        }
    }
});

// Limit Count Cart Drawer 
(function () {
  function getCurrentDate() {
    const today = new Date();
    return today.toISOString().split('T')[0];
  }

  function updateQtyForElement(element) {
    const dateId = element.getAttribute("data-id"); 
    const currentDate = getCurrentDate();
    const qtyKey = `currentQty_${dateId}`;
    const dateKey = `lastUpdateDate_${dateId}`;

    const numberElement = element.querySelector(".qty__count-number");
    const initialQty = parseInt(numberElement.textContent.trim(), 10);

    let currentQty = parseInt(localStorage.getItem(qtyKey), 10);
    const lastUpdateDate = localStorage.getItem(dateKey);

    if (isNaN(currentQty)) {
      currentQty = initialQty;
      localStorage.setItem(qtyKey, currentQty);
    }  

    if (lastUpdateDate !== currentDate) {
      currentQty = currentQty > 0 ? currentQty - 1 : initialQty;
      localStorage.setItem(qtyKey, currentQty);
      localStorage.setItem(dateKey, currentDate);
    }

    numberElement.textContent = currentQty;
  }

  function initializeAllQtyCounts() {
    const qtyElements = document.querySelectorAll(".qty__count");
    qtyElements.forEach(updateQtyForElement);
  }

  initializeAllQtyCounts();
})();

//Footer tab open last item
document.addEventListener("DOMContentLoaded", function () {
  const customElement = document.querySelector('.grid__item[data-type="custom"]');

  if (customElement) {
    const button = customElement.querySelector('button');

    if (button) {
      const clickEvent = new Event("click", {
        bubbles: true,  
        cancelable: true 
      });
      button.addEventListener("click", function () {
      });

      button.dispatchEvent(clickEvent);
    } 
  }
});